// frontend/src/pages/NonWordsWrapper.js
import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import NonWords from "./NonWords";

export default function NonWordsWrapper() {
    const { level } = useParams();
    const navigate = useNavigate();
    
    const currentLevel = parseInt(level);
    localStorage.setItem('level', level);
    
    return (
        <NonWords
            level={currentLevel}
            onValidate={() =>
                navigate(`/exercise/nonWords/reward/${currentLevel}`)
            }
        />
    );
}
